import { Component, OnInit } from '@angular/core';
import { interval } from 'rxjs';
import { Router } from '@angular/router';
declare var $: any;
@Component({
  selector: 'app-account-setting',
  templateUrl: './account-setting.component.html',
  styleUrls: ['./account-setting.component.css']
})
export class AccountSettingComponent implements OnInit {
  active = 0;
  timer: any;
  constructor(public router: Router) {
    this.timer = interval(1000).subscribe(x => {
      if (this.active < 6) {
        this.active = this.active + 1;
      } else {
        this.closeTimer();
      }
    });
  }
  closeTimer() {
    this.timer.unsubscribe();
    this.router.navigate(['/sign-up/dashboard']);
  }
  ngOnInit(): void {
  }

}
